import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import {
  IMessageHeadersParsedMimeMailAddress,
  MessageHeadersParsedMimeMailAddress
} from "./message-headers-parsed-mime-mail-address.entity";
import { MrfiktivMessageHeadersViewmodelGen } from "@/services/mrfiktiv/v1/data-contracts";

@IsFilterable
class MessageHeadersBase implements IMessageHeaders, MrfiktivMessageHeadersViewmodelGen {
  @FilterConfig({ type: MessageHeadersParsedMimeMailAddress })
  to: IMessageHeadersParsedMimeMailAddress;

  @FilterConfig({ type: MessageHeadersParsedMimeMailAddress })
  from: IMessageHeadersParsedMimeMailAddress;

  @FilterConfig({ type: MessageHeadersParsedMimeMailAddress })
  cc?: IMessageHeadersParsedMimeMailAddress;

  @FilterConfig({ type: MessageHeadersParsedMimeMailAddress })
  bcc?: IMessageHeadersParsedMimeMailAddress;

  @FilterConfig({ type: MessageHeadersParsedMimeMailAddress })
  replyTo?: IMessageHeadersParsedMimeMailAddress;

  @FilterConfig({ type: FilterTypes.STRING })
  inReplyTo?: string;

  constructor(src?: Partial<IMessageHeaders | MrfiktivMessageHeadersViewmodelGen>) {
    this.to = new MessageHeadersParsedMimeMailAddress(src?.to);
    this.from = new MessageHeadersParsedMimeMailAddress(src?.from);
    this.cc = src?.cc ? new MessageHeadersParsedMimeMailAddress(src.cc) : undefined;
    this.bcc = src?.bcc ? new MessageHeadersParsedMimeMailAddress(src.bcc) : undefined;
    this.replyTo = src?.replyTo ? new MessageHeadersParsedMimeMailAddress(src.replyTo) : undefined;
    this.inReplyTo = src?.inReplyTo;
  }
}

type IMessageHeaders = MessageHeadersBase;
const MessageHeaders = Filter.createForClass(MessageHeadersBase);
export { IMessageHeaders, MessageHeaders };
